import * as actionTypes from '../actions/actionTypes'
import {updateObject} from "../../utility";

const initialState = {
    error: null,
    loading: false,
    installations: {},
    tags: [],
    apiToken: null,
    terraformScripts: null,
};

const fetchInstalltionStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const fetchInstallationSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, installations: action.installations, tags: action.tags})
};

const fetchInstallationFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const editTagStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const editTagSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, tags: action.tags, installations: action.installations})
};

const editTagFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const regenCfStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const regenCfSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, tags: action.tags, installations: action.installations})
};

const regenCfFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const showApiTokenStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const showApiTokenSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, apiToken: action.apiToken})
};

const showApiTokenFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const showTerraformScriptsStart = (state, action) => {
    return updateObject(state, {loading: true})
}

const showTerraformScriptsSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, terraformScripts: action.terraformScripts})
}

const showTerraformScriptsFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.INSTALLATION_FETCH_START: return fetchInstalltionStart(state, action);
        case actionTypes.INSTALLATION_FETCH_SUCCESS: return fetchInstallationSuccess(state, action);
        case actionTypes.INSTALLATION_FETCH_FAIL: return fetchInstallationFail(state, action);
        case actionTypes.EDIT_TAG_START: return editTagStart(state, action);
        case actionTypes.EDIT_TAG_SUCCESS: return editTagSuccess(state, action);
        case actionTypes.EDIT_TAG_FAIL: return editTagFail(state, action);
        case actionTypes.REGEN_CF_START: return regenCfStart(state, action);
        case actionTypes.REGEN_CF_SUCCESS: return regenCfSuccess(state, action);
        case actionTypes.REGEN_CF_FAIL: return regenCfFail(state, action);
        case actionTypes.SHOW_API_TOKEN_START: return showApiTokenStart(state, action);
        case actionTypes.SHOW_API_TOKEN_SUCCESS: return showApiTokenSuccess(state, action);
        case actionTypes.SHOW_API_TOKEN_FAIL: return showApiTokenFail(state, action);
        case actionTypes.SHOW_TERRAFORM_START: return showTerraformScriptsStart(state, action);
        case actionTypes.SHOW_TERRAFORM_SUCCESS: return showTerraformScriptsSuccess(state, action);
        case actionTypes.SHOW_TERRAFORM_FAIL: return showTerraformScriptsFail(state, action);
        default: return state;
    }
};

export default reducer;

